"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var react_redux_1 = require("react-redux");
var react_i18next_1 = require("react-i18next");
var core_1 = require("@material-ui/core");
var LinkInfoEditor_1 = __importDefault(require("../../widgets/LinkInfoEditor"));
var ModalMargins_1 = __importDefault(require("./ModalMargins"));
var requests_1 = require("../../../app/util/requests");
var actions_1 = __importDefault(require("../../actions"));
var actions_2 = __importDefault(require("../../../app/components/pages/RootPage/actions"));
var useStyles = core_1.makeStyles(function (theme) {
    var _a, _b, _c;
    return core_1.createStyles({
        shortUrlText: {
            marginBottom: 8,
            marginTop: 8,
        },
        buttonWrapper: (_a = {
                display: 'flex',
                justifyContent: 'flex-end',
                flexDirection: 'column-reverse'
            },
            _a[theme.breakpoints.up('md')] = {
                flexDirection: 'row',
                marginBottom: 50,
            },
            _a.marginBottom = 80,
            _a),
        skipButton: (_b = {
                width: '100%'
            },
            _b[theme.breakpoints.up('md')] = {
                maxWidth: 135,
            },
            _b),
        saveButton: (_c = {
                width: '100%'
            },
            _c[theme.breakpoints.up('md')] = {
                maxWidth: 135,
            },
            _c),
    });
});
function AddDescriptionForm() {
    var _this = this;
    var _a = __read(react_i18next_1.useTranslation(), 1), t = _a[0];
    var classes = useStyles();
    var _b = __read(react_1.useState(''), 2), contactEmail = _b[0], setContactEmail = _b[1];
    var _c = __read(react_1.useState(true), 2), isContactEmailValid = _c[0], setIsContactEmailValid = _c[1];
    var _d = __read(react_1.useState(''), 2), description = _d[0], setDescription = _d[1];
    var _e = __read(react_1.useState(true), 2), isDescriptionValid = _e[0], setIsDescriptionValid = _e[1];
    var onContactEmailChange = function (event) {
        return setContactEmail(event.target.value);
    };
    var onDescriptionChange = function (event) {
        return setDescription(event.target.value);
    };
    var shortUrl = react_redux_1.useSelector(function (state) { return state.user.lastCreatedLink; });
    var dispatch = react_redux_1.useDispatch();
    var closeCreateUrlModal = function () { return dispatch(actions_1.default.closeCreateUrlModal()); };
    var updateLinkInformation = function () { return __awaiter(_this, void 0, void 0, function () {
        var response, jsonResponse;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, requests_1.patch('/api/user/url', {
                        contactEmail: contactEmail === '' ? null : contactEmail,
                        description: description,
                        shortUrl: shortUrl,
                    })];
                case 1:
                    response = _a.sent();
                    if (response.ok) {
                        dispatch(actions_1.default.getUrlsForUser());
                        dispatch(actions_2.default.setSuccessMessage('URL is updated.'));
                        closeCreateUrlModal();
                        return [2 /*return*/];
                    }
                    return [4 /*yield*/, response.json()];
                case 2:
                    jsonResponse = _a.sent();
                    dispatch(actions_2.default.setErrorMessage(jsonResponse.message));
                    return [2 /*return*/];
            }
        });
    }); };
    var isBothFieldsBlank = contactEmail === '' && description === '';
    var isContainsInvalidField = !(isContactEmailValid && isDescriptionValid);
    var isSaveButtonDisabled = isBothFieldsBlank || isContainsInvalidField;
    return (react_1.default.createElement("div", null,
        react_1.default.createElement(ModalMargins_1.default, null,
            react_1.default.createElement(core_1.Typography, { variant: "body2", className: classes.shortUrlText },
                react_1.default.createElement("strong", null,
                    "go.gov.kh/",
                    shortUrl)),
            react_1.default.createElement(LinkInfoEditor_1.default, { contactEmail: contactEmail, description: description, onContactEmailChange: onContactEmailChange, onDescriptionChange: onDescriptionChange, onContactEmailValidation: setIsContactEmailValid, onDescriptionValidation: setIsDescriptionValid, isMountedOnCreateUrlModal: true }),
            react_1.default.createElement("div", { className: classes.buttonWrapper },
                react_1.default.createElement(core_1.Button, { onClick: closeCreateUrlModal, size: "large", color: "primary", variant: "text", className: classes.skipButton }, t('button.skipForNow')),
                react_1.default.createElement(core_1.Button, { onClick: updateLinkInformation, disabled: isSaveButtonDisabled, color: "primary", size: "large", variant: "contained", className: classes.saveButton }, t('button.save'))))));
}
exports.default = AddDescriptionForm;
